module.exports = __webpack_public_path__ + "static/media/img105_R.f5256361.jpg";